module.exports = " <div class=vDialog v-show=display @click=hide _v-e4a3c698=\"\"> <div class=inner _v-e4a3c698=\"\"> <img src=" + require("../assets/popbg.png") + " alt=\"\" _v-e4a3c698=\"\"> <span class=msg _v-e4a3c698=\"\">{{msg}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e4a3c698!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog.vue
// module id = 103
// module chunks = 1